import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@repo/auth';
import { SettingsProvider } from '@repo/settings';
import { Toaster, DeleteConfirmDialog, DialogProvider } from '@repo/ui';
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routes } from './navigation/routing';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <AuthProvider portal="student">
          <DialogProvider>
            <RouterProvider router={routes} />
            <DeleteConfirmDialog />
            <Toaster />
          </DialogProvider>
        </AuthProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
};

export default App;
